import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { NotificationService } from 'src/app/core/notification.service'

import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import moment from 'moment-mini'
import { StatusCode } from './sale'
import { saleSelectors } from './sale.selectors'

@Injectable({
  providedIn: 'root'
})
export class PendingSaleGuard {
  constructor(
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private router: Router
  ) {}

  canActivate(): Observable<any> {
    return this.store.select(saleSelectors.selectAll).pipe(
      map((sales) =>
        sales.filter((sale) => {
          return (
            sale.statusCode == StatusCode.INFLIGHT &&
            moment().diff(moment(sale.modificationDate), 'minutes') < 15
          )
        })
      ),
      map((sales) => {
        const firstPendingSale = sales[0]
        if (!firstPendingSale) {
          return true
        } else {
          console.log(
            `PendingSaleGuard found pending sale ${firstPendingSale.id} and will redirect user`
          )

          this.notificationService.emit(
            'saleModule.handleYourPendingSale',
            'warning'
          )

          return this.router.navigateByUrl(
            `/sales/${firstPendingSale.id}/checkout`
          )
        }
      })
    )
  }
}
